import type { AvailableLegalCountryCode } from '@repo/shared-kit/constants/countries';

// FR is intentionally excluded — it's hardcoded as 'treatment' and bypasses the LD flag.
export const NATIVE_MOBILE_REGISTER_MARKETS = [
  'DE',
  'ES',
  'IT',
  'NL',
  'AT',
  'BE',
  'PT',
] as const satisfies readonly AvailableLegalCountryCode[];

const MARKET_SET: ReadonlySet<string> = new Set(NATIVE_MOBILE_REGISTER_MARKETS);

export function isNativeMobileRegisterMarket(
  country: string | null | undefined
): country is AvailableLegalCountryCode {
  return country !== null && country !== undefined && MARKET_SET.has(country);
}
